// extracted by mini-css-extract-plugin
export var bounce = "styles-module--bounce--c8a17";
export var button___desktop = "styles-module--button___desktop--b6f2e";
export var button___mobile = "styles-module--button___mobile--ce1b7";
export var card = "styles-module--card--e1aa9";
export var container = "styles-module--container--c2d37";
export var content = "styles-module--content--f24f7";
export var description = "styles-module--description--9e4d5";
export var heading = "styles-module--heading--4bc51";
export var info = "styles-module--info--f5827";
export var line = "styles-module--line--3d2c3";
export var main = "styles-module--main--79ea4";
export var number = "styles-module--number--33318";
export var number___desktop = "styles-module--number___desktop--ff0be";
export var number___mobile = "styles-module--number___mobile--f1777";
export var pulse = "styles-module--pulse--e5341";
export var subheading = "styles-module--subheading--fd34c";
export var tag = "styles-module--tag--17467";
export var tag___after = "styles-module--tag___after--59394";
export var tag___before = "styles-module--tag___before--4f62d";
export var tag___during = "styles-module--tag___during--95a4f";
export var text = "styles-module--text--50c5f";